<ng-container *transloco="let convert;">
  @if (showSharedListActionBar) {
    <div class="footer position-fixed w-100" aria-label="action-list">
      <ng-container>
        <button
          allytmln="acceptButton"
          class="btn btn-outline-primary"
          type="button"
          id="accept_all_selected"
          [attr.allytmln]="'Accept ' + itemCount"
          [attr.aria-label]="convert('vehicles.sharedListActionBar.ariaLabelBtnAccept')"
          [attr.data-track-name]="convert('vehicles.sharedListActionBar.ariaLabelBtnAccept')"
          (click)="acceptAllSelected()"
          >
          {{convert('common.btnAccept')}} ({{itemCount}})
        </button>
        @if (declineEnabled) {
          <button
            allytmln="declineButton"
            class="btn btn-outline-primary"
            type="button"
            id="decline_all_selected"
            [attr.allytmln]="'Decline ' + itemCount"
            [attr.aria-label]="convert('vehicles.sharedListActionBar.ariaLabelBtnDecline')"
            [attr.data-track-name]="convert('vehicles.sharedListActionBar.ariaLabelBtnDecline')"
            (click)="declineAllSelected()"
            >
            {{convert('common.btnDecline')}} ({{itemCount}})
          </button>
        }
        <button
          allytmln="cancelButton"
          class="btn btn-link"
          type="button"
          id="cancel_generation"
          [attr.aria-label]="convert('vehicles.sharedListActionBar.ariaLabelBtnCancel')"
          [attr.data-track-name]="convert('vehicles.sharedListActionBar.ariaLabelBtnCancel')"
          (click)="cancel()"
          >
          {{convert('common.btnCancel')}}
        </button>
      </ng-container>
    </div>
  }
</ng-container>
